import React from 'react';
import { Refresh, SwegonColors } from '@swegon-core/uic/dist/src/theme';
import { Container } from './Working.styles';

interface WorkingProps {
    width?: number;
    height?: number;
    color?: SwegonColors;
}

const Working: React.FC<WorkingProps> = ({ color }) => {
    return (
        <Container>
            <Refresh size="medium" color={color} />
        </Container>
    );
};

export default Working;
